import api, { API_PATHS } from '@/api/index';

// The backend behind these endpoints has been permanently decommissioned; every call is expected
// to fail every time, so failures are swallowed silently rather than logged as errors.
class AuthClient {
  async authToken(): Promise<string | null> {
    try {
      const response = await api.post(API_PATHS.AUTH_TOKEN);

      return response.data;
    } catch (e) {
      return null;
    }
  }

  async authLogin(address: string, token: string, signature: string): Promise<string | null> {
    const response = await api.post(API_PATHS.AUTH_LOGIN, {
      address,
      token,
      signature,
    });

    return response.data;
  }
}

const authClient = new AuthClient();

export default authClient;
